<section class="p-0 bg-card rounded-2xl deleteModal">
    <h6 class="text-center font-extrabold text-red-500">{{data.title |transloco}}</h6>
    <p class="text-center text-accent-500 mt-2">{{data.body}}</p>
    <div class="mt-4">
        <button mat-stroked-button color="primary" (click)="close()">{{'Close' |transloco}}</button>
        <button mat-stroked-button color="warn" (click)="onDeleteClick()">{{'Confirm' |transloco}}</button>
    </div>
</section>